export const blockScrollOnBody = () => {
  document.documentElement.style.scrollbarGutter = 'stable'
  document.body.style.overflowX = 'hidden'
  document.body.style.overflowY = 'hidden'
}

export const releaseScrollOnBody = () => {
  document.documentElement.style.scrollbarGutter = 'auto'
  document.body.style.overflowX = ''
  document.body.style.overflowY = ''
}
